<template>
  <div>
    <template v-if="memberIdentity">
      <v-card flat>
        <v-card-text>
          <v-row class="pa-0">
            <!-- <v-col
              cols="auto"
              v-if="Object.keys(headersDictionary).indexOf('First Name') > -1"
            >
              <span class="minfo">
                {{ $t("headers.members_management.First Name") }}
              </span>
              <br />
              {{ memberIdentity.CurrentMember.FirstName }}
            </v-col>
            <v-col
              cols="auto"
              v-if="Object.keys(headersDictionary).indexOf('Last Name') > -1"
            >
              <span class="minfo">
                {{ $t("headers.members_management.Last Name") }}
              </span>
              <br />
              {{ memberIdentity.CurrentMember.LastName }}
            </v-col> -->
            <v-col
              cols="auto"
              v-if="
                Object.keys(headersDictionary).indexOf('Date Of Birth') > -1
              "
            >
              <span class="minfo">
                {{ $t("headers.members_management.Date Of Birth") }}
              </span>
              <br />
              {{ formatDate(memberIdentity.CurrentMember.DateOfBirth) }}
            </v-col>
            <!-- <v-col
              cols="auto"
              v-if="Object.keys(headersDictionary).indexOf('Country') > -1"
            >
              <span class="minfo">
                {{ $t("headers.members_management.Address") }}
                <br />
              </span>
              {{ displayAddress() }}
              <v-btn
                v-if="
                  this.memberIdentity.CurrentContactInformation &&
                    this.memberIdentity.CurrentContactInformation.Address
                "
                small
                text
                @click="addressDialog = true"
              >
                {{ $t("globals.edit") }}
              </v-btn>
              <v-btn v-else small text @click="addressDialog = true">
                {{ $t("globals.add") }}
              </v-btn>
            </v-col> -->
            <v-col
              cols="auto"
              v-if="
                Object.keys(headersDictionary).indexOf('Account Number') > -1
              "
            >
              <span class="minfo">
                {{ $t("components.memberview.direct_deposit") }}
                <br />
              </span>
              <!-- {{ displayDirectDeposit() }} -->
              <div class="row no-gutters">
                <template v-if="memberIdentity.CurrentBankAccount">
                  <div
                    cols="auto"
                    v-if="
                      Object.keys(headersDictionary).indexOf('Account Number') >
                      -1
                    "
                  >
                    <span class="minfo">
                      {{ $t("headers.members_management.Account Number") }}
                    </span>
                    <br />
                    {{ memberIdentity.CurrentBankAccount.AccountNumber }}
                  </div>
                  <div
                    cols="auto"
                    v-if="
                      Object.keys(headersDictionary).indexOf('Transit Number') >
                      -1
                    "
                  >
                    <span class="minfo">
                      {{ $t("headers.members_management.Transit Number") }}
                    </span>
                    <br />
                    {{ memberIdentity.CurrentBankAccount.TransitNumber }}
                  </div>
                  <div
                    cols="auto"
                    v-if="
                      Object.keys(headersDictionary).indexOf(
                        'Institution Number'
                      ) > -1
                    "
                  >
                    <span class="minfo">
                      {{ $t("headers.members_management.Institution Number") }}
                    </span>
                    <br />
                    {{ memberIdentity.CurrentBankAccount.InstitutionNumber }}
                  </div>
                  <div
                    cols="auto"
                    v-if="
                      Object.keys(headersDictionary).indexOf(
                        'Verify Direct Deposit'
                      ) > -1
                    "
                  >
                    <span class="minfo">
                      {{
                        $t("headers.members_management.Verify Direct Deposit")
                      }}
                    </span>
                    <br />
                    {{
                      memberIdentity.CurrentBankAccount.VerifyDirectDeposit
                        ? $t("globals.yes")
                        : $t("globals.no")
                    }}
                  </div>
                </template>
                <div cols="auto">
                  <v-btn
                    v-if="memberIdentity.CurrentBankAccount"
                    small
                    text
                    @click="directDepositDialog = true"
                  >
                    {{ $t("globals.edit") }}
                  </v-btn>
                  <v-btn v-else small text @click="directDepositDialog = true">
                    {{ $t("globals.add") }}
                  </v-btn>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-row class="row no-gutters">
        <div class="col-12 col-md-12 col-lg-12 col-xl-12">
          <v-card-text>
            <span class="minfo">
              {{ $t("globals.dependants") }}
            </span>
          </v-card-text>
          <br />
          <!-- <pbas-simple-table
            ref="dependants"
            :dataProvider="odataDependantsProvider"
            fileNamePrefix="dependants"
            identifier="search_member_claims_dependant"
            @error="error = $event"
          ></pbas-simple-table> -->
          <dependants
            :memberName="getName()"
            :provider="odataDependantsProvider"
            :memberId="memberIdentity.Id"
            :identifier="'claim-dependants'"
            :coverageEffectiveDate="memberIdentity.PlanEntryDate"
            :policyIdentities="policyIdentities"
            :beneficiaryStatements="beneficiaryStatements"
            planType="HW"
            :planId="memberIdentity.PlanIdentityId"
            @reload-member-identity="$emit('reload-member-identity')"
          ></dependants>
        </div>
      </v-row>
    </template>
    <v-dialog scrollable v-model="loading" persistent max-width="200">
      <v-card>
        <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog scrollable v-model="addressDialog" persistent max-width="1200">
      <material-card
        v-if="addressDialog"
        :title="
          memberIdentity.CurrentContactInformation &&
          memberIdentity.CurrentContactInformation.Address
            ? $t('components.claims.member_details.edit_address_{0}', [
                getName(),
              ])
            : $t('components.claims.member_details.add_address_{0}', [
                getName(),
              ])
        "
        icon="contact_mail"
        :color="$vuetify.theme.themes.light.primary"
      >
        <v-card-text>
          <!-- <div class="row">
            <div class="col-12 col-md-4 col-lg-3">
              <pbas-date-picker
                :disabled="loading"
                :label="$t('headers.members_management.Effective Date')"
                :value="effectiveDate"
                @update-date="effectiveDate = $event"
                :allowedDates="coverageAllowedDates"
                :class="'required'"
                :rules="[$rules.required, rules.coverageEffectiveDate]"
              ></pbas-date-picker>
            </div>
          </div> -->
          <v-container fluid grid-list-md v-if="loading">
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
          <template v-else>
            <span class="text-h6 ml-1 required-label">
              {{ $t("globals.address") }}
            </span>
            <canada-post-address
              :address="contactInfo.Address"
              @update-address="contactInfo.Address = $event"
              @valid="validAddress=$event"
              :isRequired="true"
            />
          </template>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color
            text
            @click="
              addressDialog = false;
              address = null;
              effectiveDate = null;
            "
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :loading="saving"
            :disabled="!effectiveDate || !validAddress"
            color="primary"
            @click="saveContactInfo"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="directDepositDialog"
      persistent
      max-width="1200"
    >
      <material-card
        v-if="directDepositDialog"
        :title="
          memberIdentity.CurrentBankAccount
            ? $t(
                'components.claims.member_details.edit_direct_deposit_info_{0}',
                [getName()]
              )
            : $t(
                'components.claims.member_details.add_direct_deposit_info_{0}',
                [getName()]
              )
        "
        icon="edit"
        :color="$vuetify.theme.themes.light.primary"
      >
        <v-card-text>
          <v-form v-model="valid" ref="directDepositForm">
            <div class="row">
              <!-- <div class="col-12 col-md-4 col-lg-3">
                <pbas-date-picker
                  :disabled="loading"
                  :label="$t('headers.members_management.Effective Date')"
                  :value="effectiveDate"
                  @update-date="effectiveDate = $event"
                  :allowedDates="coverageAllowedDates"
                  :class="'required'"
                  :rules="[$rules.required, rules.coverageEffectiveDate]"
                ></pbas-date-picker>
              </div> -->
              <v-container fluid grid-list-md v-if="loading">
                <v-layout row justify-center>
                  <v-flex xs12 sm6 md4 lg3>
                    <v-progress-circular indeterminate></v-progress-circular>
                  </v-flex>
                </v-layout>
              </v-container>
              <template v-else>
                <!-- <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="planType === 'Pension'"
                >
                  <trans-select
                    :item="directDeposit"
                    propertyName="SourceOfInformation"
                    :items="options.Models.SourceOfInformation"
                    :label="$t('globals.source_of_information')"
                  ></trans-select>
                </div> -->
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf(
                      'Institution Number'
                    ) > -1
                  "
                >
                  <no-autocomplete-textfield
                    :disabled="
                      memberIdentity.TerminatedAt !== null &&
                      memberIdentity.TerminatedAt !== undefined
                    "
                    :label="$t('headers.members_management.Institution Number')"
                    v-model="directDeposit.InstitutionNumber"
                    :rules="
                      [$rules.canadianBankInstitutionNumber].concat(
                        $rules.columnRules(
                          headersDictionary['Institution Number']
                        )
                      )
                    "
                    :class="
                      headersDictionary['Institution Number'].isOptional ===
                      false
                        ? 'required'
                        : []
                    "
                  ></no-autocomplete-textfield>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf('Account Number') >
                    -1
                  "
                >
                  <no-autocomplete-textfield
                    :disabled="
                      memberIdentity.TerminatedAt !== null &&
                      memberIdentity.TerminatedAt !== undefined
                    "
                    :label="$t('headers.members_management.Account Number')"
                    v-model="directDeposit.AccountNumber"
                    :rules="
                      [$rules.canadianBankAccountNumber].concat(
                        $rules.columnRules(headersDictionary['Account Number'])
                      )
                    "
                    :class="
                      headersDictionary['Account Number'].isOptional === false
                        ? 'required'
                        : []
                    "
                  ></no-autocomplete-textfield>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf('Transit Number') >
                    -1
                  "
                >
                  <no-autocomplete-textfield
                    :disabled="
                      memberIdentity.TerminatedAt !== null &&
                      memberIdentity.TerminatedAt !== undefined
                    "
                    :label="$t('headers.members_management.Transit Number')"
                    v-model="directDeposit.TransitNumber"
                    :rules="
                      [$rules.canadianBankTransitNumber].concat(
                        $rules.columnRules(headersDictionary['Transit Number'])
                      )
                    "
                    :class="
                      headersDictionary['Transit Number'].isOptional === false
                        ? 'required'
                        : []
                    "
                  ></no-autocomplete-textfield>
                </div>
                <div
                  class="col-12 col-md-4 col-lg-3"
                  v-if="
                    Object.keys(headersDictionary).indexOf(
                      'Verify Direct Deposit'
                    ) > -1
                  "
                >
                  <v-checkbox
                    :label="
                      $t('headers.members_management.Verify Direct Deposit')
                    "
                    v-model="directDeposit.VerifyDirectDeposit"
                  ></v-checkbox>
                </div>
              </template>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color
            text
            @click="
              directDepositDialog = false;
              directDeposit = null;
              effectiveDate = null;
            "
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :loading="saving"
            :disabled="
              !valid ||
              !effectiveDate ||
              (memberIdentity.TerminatedAt !== null &&
                memberIdentity.TerminatedAt !== undefined)
            "
            color="primary"
            @click="validateDirectDeposit"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="confirmBankAccountDialog"
      persistent
      max-width="500"
    >
      <material-card
        :title="
          $t('components.addmemberwizard.confirm_bank_account_dialog_title')
        "
        :color="$vuetify.theme.themes.light.success"
        icon="done"
      >
        <v-card-actions>
          <v-btn color text @click="confirmBankAccountDialog = false">
            {{ $t("globals.close") }}
          </v-btn>
          <v-spacer />
          <v-btn
            color="primary"
            @click="
              confirmBankAccountDialog = false;
              saveDirectDeposit();
            "
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <error-handler :error="error"></error-handler>
    <v-snackbar
      v-model="snackbar"
      :color="color"
      :multi-line="mode === 'multi-line'"
      :timeout="timeout"
      :vertical="mode === 'vertical'"
    >
      {{ $t(message) }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ErrorHandler from "@/components/ErrorHandler.vue";
import DependantsHeaders from "@/headers/ClaimDependants";
import { translate2 } from "@/trans2";
import { ODataProvider } from "pbas-vue-components";
import { locker } from "@/mixins/locker";
import CanadaPostAddress from "@/components/CanadaPostAddress.vue";
import Dependants from "@/components/Claims/Dependants";
import NoAutocompleteTextfield from "../NoAutocompleteTextfield.vue";
export default {
  components: {
    ErrorHandler,
    CanadaPostAddress,
    Dependants,
    NoAutocompleteTextfield,
  },
  props: {
    memberIdentity: {
      type: Object,
      default: () => null,
    },
  },
  mixins: [locker],
  data() {
    return {
      odataDependantsProvider: undefined,
      error: null,
      effectiveDate: null,
      // rules: {
      //   coverageEffectiveDate: (v) => {
      //     if (v === undefined || v === null || v === "") {
      //       return true;
      //     }
      //     if (
      //       this.memberIdentity === null ||
      //       this.memberIdentity === undefined ||
      //       this.memberIdentity.PlanEntryDate === null ||
      //       this.memberIdentity.PlanEntryDate === undefined
      //     ) {
      //       return true;
      //     }
      //     const n = Date.parse(this.memberIdentity.PlanEntryDate);
      //     const d = new Date(n);
      //     if (!this.isDate(v)) {
      //       return this.$t("validation.date_{0}", [
      //         this.formatValidationDate(d),
      //       ]);
      //     }
      //     const val = new Date(Date.parse(v));
      //     return (
      //       val >= d ||
      //       this.$t("validation.date_{0}", [this.formatValidationDate(d)])
      //     );
      //   },
      // },
      headersDictionary: {},
      addressDialog: false,
      saving: false,
      contactInfoQuery: null,
      contactInfo: null,
      policyIdentities: [],
      beneficiaryStatements: [],
      directDepositDialog: false,
      directDeposit: {},
      directDepositQuery: null,
      valid: false,
      confirmBankAccountDialog: false,
      loading: false,
      validAddress: false,
      snackbar: false,
      color: "",
      mode: "",
      timeout: 2500,
      message: "",
    };
  },
  watch: {
    memberIdentity: {
      handler(v) {
        if (v) {
          this.loadMemberDetails();
        }
      },
      immediate: true,
    },
    addressDialog: {
      async handler(v) {
        if (v) {
          this.effectiveDate = this.memberIdentity.PlanEntryDate;
          this.loadAddress(this.effectiveDate);
        }
      },
    },
    directDepositDialog: {
      async handler(v) {
        if (v) {
          this.effectiveDate = this.memberIdentity.PlanEntryDate;
          this.loadDirectDeposit(this.effectiveDate);
        }
      },
    },
  },
  computed: {},
  mounted() {
    if (this.memberIdentity) {
      this.loadMemberDetails();
    }
  },
  methods: {
    ...mapActions("claims", ["getClaimDates"]),
    ...mapActions("plansMembers", [
      "getMembersManagementColumns",
      "getContactInfoByEffectiveDate",
      "updateMemberContactInfo",
      "getMemberInfo",
      "getPolicyIdentitiesByMemberIdentityId",
      "validateBankAccount",
      "updateMemberDirectDeposit",
      "getDirectDepositByEffectiveDate",
    ]),
    async loadDirectDeposit(effectiveDate) {
      this.loading = true;
      try {
        if (this.lockId) {
          this.directDeposit = (
            await this.getDirectDepositByEffectiveDate({
              planIdentityId: this.memberIdentity.PlanIdentityId,
              memberIdentityId: this.memberIdentity.Id,
              effectiveDate: effectiveDate,
              odataQuery: this.directDepositQuery,
            })
          ).data;
        } else {
          this.directDeposit = await this.lock(
            this.getDirectDepositByEffectiveDate,
            {
              planIdentityId: this.memberIdentity.PlanIdentityId,
              memberIdentityId: this.memberIdentity.Id,
              effectiveDate: effectiveDate,
              odataQuery: this.directDepositQuery,
              dialogs: this.dialogs,
              dialog: "directDeposit",
            },
            () => {
              this.directDepositDialog = false;
            }
          );
        }
        if (!this.directDeposit) {
          this.directDeposit = {};
        }
      } catch (error) {
        this.error = error;
      }
      this.loading = false;
    },
    async loadAddress(effectiveDate) {
      this.loading = true;
      try {
        let contactInfo;
        if (this.lockId) {
          contactInfo = (
            await this.getContactInfoByEffectiveDate({
              planIdentityId: this.memberIdentity.PlanIdentityId,
              memberIdentityId: this.memberIdentity.Id,
              effectiveDate: effectiveDate,
              odataQuery: this.contactInfoQuery,
            })
          ).data;
        } else {
          contactInfo = await this.lock(
            this.getContactInfoByEffectiveDate,
            {
              planIdentityId: this.memberIdentity.PlanIdentityId,
              memberIdentityId: this.memberIdentity.Id,
              effectiveDate: effectiveDate,
              odataQuery: this.contactInfoQuery,
              dialogs: this.dialogs,
              dialog: "contactInfo",
            },
            () => {
              this.addressDialog = false;
            }
          );
        }
        //console.log(contactInfo);
        if (!contactInfo) {
          contactInfo = {
            // Address: {},
            // Identity: {},
          };
        }

        this.contactInfo = contactInfo;
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    getName() {
      // console.log(this.memberIdentity);
      if (this.memberIdentity === null || this.memberIdentity === undefined) {
        return;
      }
      if (this.memberIdentity.CurrentMember) {
        if (
          this.memberIdentity.CurrentMember.FirstName &&
          this.memberIdentity.CurrentMember.LastName
        ) {
          return `${this.memberIdentity.CurrentMember.FirstName} ${this.memberIdentity.CurrentMember.LastName}`;
        } else if (this.memberIdentity.CurrentMember.FirstName) {
          return this.memberIdentity.CurrentMember.FirstName;
        } else if (this.memberIdentity.CurrentMember.LastName) {
          return this.memberIdentity.CurrentMember.LastName;
        }
      }
      if (this.memberIdentity.MemberIdentification.Certificate) {
        return this.memberIdentity.MemberIdentification.Certificate;
      }
      return "";
    },
    isDate(val) {
      if (
        new RegExp(/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/).test(
          val
        )
      ) {
        return !isNaN(Date.parse(val));
      }
      return false;
    },
    async saveContactInfo() {
      this.saving = true;
      try {
        let member = JSON.parse(JSON.stringify(this.contactInfo));

        if (member.LanguageChoice) {
          member.LanguageChoiceId = member.LanguageChoice.Id;
          delete member.LanguageChoice;
        }
        if (member.CommunicationPreference) {
          member.CommunicationPreferenceId = member.CommunicationPreference.Id;
          delete member.CommunicationPreference;
        }
        if (member.Address) {
          if (Object.keys(member.Address).length > 0) {
            if (member.Address.Country) {
              member.Address.CountryId = member.Address.Country.Id;
              delete member.Address.Country;
            }
            if (member.Address.Province) {
              member.Address.ProvinceId = member.Address.Province.Id;
              delete member.Address.Province;
            }
            // member.Address.PostalCode = this.unmask(member.Address.PostalCode, this.postalCodeMask);
          } else {
            delete member.Address;
          }
        } else {
          delete member.Address;
        }

        // if (member.PhoneNumber!== null && member.PhoneNumber !== undefined) {
        //   member.PhoneNumber = this.unmask(member.PhoneNumber, this.telephoneMask);
        // }

        delete member["@odata.context"];
        // delete member.Identity;

        member.EffectiveDate = this.effectiveDate;
        member.IdentityId = this.memberIdentity.Id;
        member.PlanIdentityId = this.memberIdentity.PlanIdentityId;

        if (member.SourceOfInformation) {
          member.SourceOfInformationId = member.SourceOfInformation.Id;
          delete member.SourceOfInformation;
        }

        await this.updateMemberContactInfo({
          planIdentityId: this.memberIdentity.PlanIdentityId,
          memberIdentityId: this.memberIdentity.Id,
          payload: member,
        });
        this.addressDialog = false;
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.address = null;
        this.effectiveDate = null;
        this.$emit("reload-member-identity");
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    // coverageAllowedDates(val) {
    //   const n = Date.parse(val);
    //   const d = new Date(n);
    //   let n2 = Date.parse(this.memberIdentity.PlanEntryDate);
    //   const d2 = new Date(n2);
    //   return d >= d2;
    // },
    translate2(item, field) {
      return translate2(item, field);
    },
    async loadMemberDetails() {
      this.loading = true;
      try {
        const headers = (
          await this.getMembersManagementColumns(
            this.memberIdentity.PlanIdentityId
          )
        ).data;
        for (const header of headers) {
          if (header.onEdit === "Edit" || header.onEdit === "View") {
            this.headersDictionary[header.text] = header;
          }
        }
        this.contactInfoQuery = this.$helpers.createContactInfoQuery(headers);
        this.directDepositQuery =
          this.$helpers.createDirectDepositQuery(headers);

        const query = `$select=Id&$expand=BeneficiaryStatements($expand=DeclarationForm($expand=FileSegments),PolicyIdentities($select=Id;$expand=Current($select=Number)),
        Beneficiaries($expand=Trustee($expand=BeneficiaryRelationship,BeneficiaryType),BeneficiaryRelationship($expand=Translations),BeneficiaryType($expand=Translations),Gender($expand=Translations),Title($expand=Translations),Suffix($expand=Translations),DependantIdentity($expand=Current($expand=Gender($expand=Translations),Title($expand=Translations),Suffix($expand=Translations))))),
        CurrentMemberBenefits($select=Id;$expand=CurrentBenefit($select=Id;))`;
        const member = (
          await this.getMemberInfo({
            planIdentityId: this.memberIdentity.PlanIdentityId,
            memberIdentityId: this.memberIdentity.Id,
            odataQuery: query,
          })
        ).data;
        this.beneficiaryStatements = member.BeneficiaryStatements;
        // console.log(this.beneficiaryStatements);
        const usedPolicies = [];
        member.BeneficiaryStatements.forEach((bs) =>
          usedPolicies.push(...bs.PolicyIdentities.map((p) => p.Id))
        );

        let policies = (
          await this.getPolicyIdentitiesByMemberIdentityId({
            planIdentityId: this.memberIdentity.PlanIdentityId,
            memberIdentityId: this.memberIdentity.Id,
          })
        ).data.value;

        this.policyIdentities = policies
          .map((o) => {
            return {
              Id: o.Id,
              Name: o.Current.Number,
            };
          })
          .filter((o) => usedPolicies.filter((oo) => oo === o.Id).length === 0);
        // console.log(this.policyIdentities);

        this.odataDependantsProvider = new ODataProvider(
          this.$axiosHttp,
          `plans/${this.memberIdentity.PlanIdentityId}/members/${this.memberIdentity.Id}/dependants`,
          DependantsHeaders
        );
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    formatValidationDate(d) {
      let month = (d.getUTCMonth() + 1).toString();
      if (month.length === 1) {
        month = "0" + month;
      }
      let day = d.getUTCDate().toString();
      if (day.length === 1) {
        day = "0" + day;
      }
      return `${d.getUTCFullYear()}-${month}-${day}`;
    },
    formatDate(dateString) {
      if (dateString === undefined || dateString === null) {
        return "";
      }
      const [date, time] = dateString.split("T");
      const [year, month, day] = date.split("-");
      return `${year}-${month}-${day}`;
    },
    displayAddress() {
      let res = "";
      // console.log(this.memberIdentity);
      if (
        this.memberIdentity.CurrentContactInformation &&
        this.memberIdentity.CurrentContactInformation.Address
      ) {
        // console.log("address:   -----------------------", this.memberIdentity);
        if (this.memberIdentity.CurrentContactInformation.Address.SuiteNumber) {
          res +=
            this.memberIdentity.CurrentContactInformation.Address.SuiteNumber;
        }
        if (
          this.memberIdentity.CurrentContactInformation.Address.StreetNumber
        ) {
          if (res.length > 0) {
            res += ", ";
          }
          res +=
            this.memberIdentity.CurrentContactInformation.Address.StreetNumber.toString();
        }
        if (this.memberIdentity.CurrentContactInformation.Address.StreetName) {
          if (res.length > 0) {
            res += ", ";
          }
          res +=
            this.memberIdentity.CurrentContactInformation.Address.StreetName;
        }
        if (res.length > 0) {
          res += ", ";
        }
        if (
          this.memberIdentity.CurrentContactInformation.Address.Country.IsOther
        ) {
          res += this.memberIdentity.CurrentContactInformation.Address.City;
          if (
            this.memberIdentity.CurrentContactInformation.Address.OtherProvince
          ) {
            res +=
              ", " +
              this.memberIdentity.CurrentContactInformation.Address
                .OtherProvince;
          }
          if (
            this.memberIdentity.CurrentContactInformation.Address
              .OtherPostalCode
          ) {
            res +=
              " " +
              this.memberIdentity.CurrentContactInformation.Address
                .OtherPostalCode;
          }
          res +=
            " " +
            this.memberIdentity.CurrentContactInformation.Address.OtherCountry;
        } else {
          res +=
            this.memberIdentity.CurrentContactInformation.Address.City +
            ", " +
            this.memberIdentity.CurrentContactInformation.Address.Province.Code;
          if (
            this.memberIdentity.CurrentContactInformation.Address.PostalCode
          ) {
            res +=
              " " +
              this.memberIdentity.CurrentContactInformation.Address.PostalCode;
          }
        }
      }
      return res;
    },
    displayDirectDeposit() {
      let res = "";
      // console.log(this.memberIdentity);
      if (this.memberIdentity.CurrentBankAccount) {
        // console.log("address:   -----------------------", this.memberIdentity);
        if (this.memberIdentity.CurrentContactInformation.Address.SuiteNumber) {
          res +=
            this.memberIdentity.CurrentContactInformation.Address.SuiteNumber;
        }
        if (
          this.memberIdentity.CurrentContactInformation.Address.StreetNumber
        ) {
          if (res.length > 0) {
            res += ", ";
          }
          res +=
            this.memberIdentity.CurrentContactInformation.Address.StreetNumber.toString();
        }
        if (this.memberIdentity.CurrentContactInformation.Address.StreetName) {
          if (res.length > 0) {
            res += ", ";
          }
          res +=
            this.memberIdentity.CurrentContactInformation.Address.StreetName;
        }
        if (res.length > 0) {
          res += ", ";
        }
        if (
          this.memberIdentity.CurrentContactInformation.Address.Country.IsOther
        ) {
          res += this.memberIdentity.CurrentContactInformation.Address.City;
          if (
            this.memberIdentity.CurrentContactInformation.Address.OtherProvince
          ) {
            res +=
              ", " +
              this.memberIdentity.CurrentContactInformation.Address
                .OtherProvince;
          }
          if (
            this.memberIdentity.CurrentContactInformation.Address
              .OtherPostalCode
          ) {
            res +=
              " " +
              this.memberIdentity.CurrentContactInformation.Address
                .OtherPostalCode;
          }
          res +=
            " " +
            this.memberIdentity.CurrentContactInformation.Address.OtherCountry;
        } else {
          res +=
            this.memberIdentity.CurrentContactInformation.Address.City +
            ", " +
            this.memberIdentity.CurrentContactInformation.Address.Province.Code;
          if (
            this.memberIdentity.CurrentContactInformation.Address.PostalCode
          ) {
            res +=
              " " +
              this.memberIdentity.CurrentContactInformation.Address.PostalCode;
          }
        }
      }
      return res;
    },
    async validateDirectDeposit() {
      if (this.directDeposit) {
        if (Object.keys(this.directDeposit).length > 0) {
          this.saving = true;
          try {
            const valid = (
              await this.validateBankAccount({
                payload: {
                  InstitutionNumber: this.directDeposit.InstitutionNumber,
                  TransitNumber: this.directDeposit.TransitNumber,
                },
              })
            ).data;

            if (!valid) {
              this.confirmBankAccountDialog = true;
            } else {
              await this.saveDirectDeposit();
            }
          } catch (error) {
            this.error = error;
          } finally {
            this.saving = false;
          }
        } else {
          this.saveDirectDeposit();
        }
      } else {
        this.saveDirectDeposit();
      }
    },
    async saveDirectDeposit() {
      this.saving = true;
      try {
        let bankAccount = JSON.parse(JSON.stringify(this.directDeposit));
        if (bankAccount) {
          // if (Object.keys(bankAccount).length > 0) {
          // if (bankAccount.AccountType) {
          //   bankAccount.AccountTypeId = bankAccount.AccountType.Id;
          //   delete bankAccount.AccountType;
          // }
          // } else {
          //   delete bankAccount;
          // }
        } else {
          // delete bankAccount;
        }
        delete bankAccount["@odata.context"];

        bankAccount.EffectiveDate = this.effectiveDate;
        bankAccount.IdentityId = this.memberIdentity.Id;
        if (bankAccount.SourceOfInformation) {
          bankAccount.SourceOfInformationId =
            bankAccount.SourceOfInformation.Id;
          delete bankAccount.SourceOfInformation;
        }

        await this.updateMemberDirectDeposit({
          planIdentityId: this.memberIdentity.PlanIdentityId,
          memberIdentityId: this.memberIdentity.Id,
          payload: bankAccount,
        });
        this.directDepositDialog = false;
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.directDeposit = {};
        this.effectiveDate = null;
        this.$emit("reload-member-identity");
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
  },
};
</script>
<style scoped>
.minfo {
  font-weight: bold;
  color: #222;
}
</style>
